export default __webpack_public_path__ + "static/media/survey-longName.8320b212.png";